import { render, staticRenderFns } from "./offer-group-form.vue?vue&type=template&id=5efbb2ea"
import script from "./offer-group-form.vue?vue&type=script&lang=js"
export * from "./offer-group-form.vue?vue&type=script&lang=js"
import style0 from "./offer-group-form.vue?vue&type=style&index=0&id=5efbb2ea&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports